import { css } from '@emotion/react';

/**
 * Show a text-ellipsis on overflow.
 * The size of the parent must be fixed.
 */
export const textEllipsis = css`
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: inline-block;
`;
